import React from 'react';
import Table from '../../../common/PDF/Table';
import { splitByThousands, addPercent } from '../../../../helpers/NumberFormatter';

export default ({ data }) => {
	const row = data[0];

	// Extract keys and limit to at most 10
	let keys = Object.keys(row);
	if (keys.length > 10) {
		keys = keys.slice(0, 10);
	}

	// Calculate width based on the constrained count
	const columnWidth = Math.floor(100 / keys.length);
	
	const columns = keys.map((key) => ({
		key, 
		title: key, 
		width: columnWidth, 
		fontSize: 5,
		formatFn: key === 'period' ? undefined : splitByThousands	
	}));
	
	return (
		<Table
			columns={columns}
			items={data}
		/>
	);
};